import { EmbedClient } from '../../login/v1/typings';

export const DT_EMBED_CLIENT_STORAGE_KEY = 'DT_EMBED_CLIENT';

export function persistEmbedClientToSession(embedClient: string | null): void {
  if (!embedClient || typeof sessionStorage === 'undefined') {
    return;
  }
  if (
    embedClient !== EmbedClient.SALESFORCE &&
    embedClient !== EmbedClient.SALESFORCEV2 &&
    embedClient !== EmbedClient.DYNAMICS365
  ) {
    return;
  }
  try {
    sessionStorage.setItem(DT_EMBED_CLIENT_STORAGE_KEY, embedClient);
  } catch {
    // sessionStorage may be unavailable (privacy mode, quota)
  }
}
